
import EditorList from "Editors/EditorList";
import EditorListItem from "Editors/EditorListItem";
import EditorTipTap from "Editors/EditorTipTap";
export default {
  components: {
    EditorList,
    EditorTipTap,
    EditorListItem,
  },
  data() {
    return {
      options: [
        {
          name: "icon",
          label: "Icon",
          type: "text",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
        },
      ],
    };
  },
};
